/* INTEGY V696 — authoritative large-collection count/status ownership + exact indexed Clearance sold-out pagination + lean demand-driven in-stock renderer for oversized non-indexed collections.
   Sold-out mode first asks Shopify for the filtered source-page count. When the sold-out universe is
   reasonably sized, V675 collects the complete lightweight sold-out list, caches it for the session,
   and paginates the exact matching set 72 products at a time. In-stock remains demand-driven because
   that universe can contain thousands of products. Existing indexed owners remain preferred for
   /all, All Integy Hop-Up Parts, and Traxxas. */
(function () {
  'use strict';
  if (window.IntegyV681LargeCollectionStockOwner || window.IntegyV651LargeCollectionStockOwner) return;


  var CONFIG = window.INTEGY_V651_LARGE_STOCK_CONFIG || {};
  var PAGE_SIZE = Number(window.INTEGY_PRODUCTS_PER_PAGE || 72) || 72;
  var FRESH_CACHE_TTL = 15 * 60 * 1000;
  var SOURCE_PAGE_SIZE = 100;
  var INITIAL_SOURCE_PAGES = 1;          // first request is only 100 source products
  var FIRST_PAGE_HARD_CAP_MOBILE = 1;   // strict 100-product page-1 front load
  var FIRST_PAGE_HARD_CAP_DESKTOP = 1;  // same predictable 100-product ceiling on desktop
  var MAX_FRESH_DEEP_SOURCE_PAGES = 4;  // never front-load more than 400 source products on a fresh deep link
  var REQUEST_TIMEOUT = 10000;
  var MAX_ATTEMPTS = 3;
  var FULL_OUT_SOURCE_PAGE_CAP = 20;   // collect at most 2,000 filtered sold-out records automatically
  var FULL_OUT_WORKERS = 4;            // small bounded parallelism; current Clearance sold-out set is only a few pages
  var ROOT = document.documentElement;

  function params() {
    try { return new URLSearchParams(location.search || ''); }
    catch (error) { return new URLSearchParams(); }
  }
  function pathInfo() {
    var parts = String(location.pathname || '').split('/').filter(Boolean);
    var at = parts.indexOf('collections');
    return {
      handle: at >= 0 && parts[at + 1] ? decodeURIComponent(parts[at + 1]).toLowerCase() : '',
      tags: at >= 0 && parts.length > at + 2 ? parts.slice(at + 2).map(function (part) { return decodeURIComponent(part); }).join('/') : ''
    };
  }
  function stockMode() {
    var query = params();
    var custom = String(query.get('integy_stock') || '').toLowerCase();
    var native = query.get('filter.v.availability');
    if (native === '0' || custom === 'out') return 'out';
    if (native === '1' || custom === 'in') return 'in';
    return 'all';
  }
  function active() {
    var info = pathInfo();
    var mode = stockMode();
    return !!CONFIG.active && !CONFIG.indexed && Number(CONFIG.count || 0) > 5000 && info.handle === String(CONFIG.handle || '').toLowerCase() && (mode === 'in' || mode === 'out');
  }
  if (!active()) {
    ROOT.classList.remove('integy-v651-large-stock-loading');
    return;
  }

  window.IntegyV651LargeStockOwnerActive = true;
  window.IntegyV651SaleStockOwnerActive = true; // backward-compatible alias for older guards
  window.IntegyV648SaleStockOwnerActive = true;
  window.IntegyV645SaleStockOwnerActive = true; // compatibility: V577 checks this guard
  window.IntegyV681LargeCollectionStockOwner = {
    version: 'V696',
    sourceBatchSize: SOURCE_PAGE_SIZE,
    visiblePageSize: PAGE_SIZE,
    owner: 'live-v47-unfiltered-demand-large-collection-stock',
    fullOutSourcePageCap: FULL_OUT_SOURCE_PAGE_CAP,
    initialSourcePages: INITIAL_SOURCE_PAGES,
    mobileFirstPageCap: FIRST_PAGE_HARD_CAP_MOBILE,
    desktopFirstPageCap: FIRST_PAGE_HARD_CAP_DESKTOP
  };
  window.IntegyV677LargeCollectionStockOwner = window.IntegyV681LargeCollectionStockOwner; // compatibility alias
  window.IntegyV675LargeCollectionStockOwner = window.IntegyV681LargeCollectionStockOwner;
  window.IntegyV674LargeCollectionStockOwner = window.IntegyV681LargeCollectionStockOwner; // compatibility alias
  window.IntegyV673LargeCollectionStockOwner = window.IntegyV681LargeCollectionStockOwner; // compatibility alias
  window.IntegyV672LargeCollectionStockOwner = window.IntegyV681LargeCollectionStockOwner; // compatibility alias
  window.IntegyV651LargeCollectionStockOwner = window.IntegyV681LargeCollectionStockOwner; // compatibility alias
  window.IntegyV651SaleStockOwner = window.IntegyV681LargeCollectionStockOwner; // compatibility alias

  function text(value) { return String(value == null ? '' : value); }
  function esc(value) {
    return text(value).replace(/[&<>"]/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[char];
    });
  }
  function wait(ms) {
    return new Promise(function (resolve) { window.setTimeout(resolve, ms); });
  }
  function money(cents) {
    var amount = (Number(cents) || 0) / 100;
    var code = 'USD';
    try {
      code = (window.Shopify && Shopify.currency && Shopify.currency.active) ||
        ((window.INTEGY_CURRENCY_CONTEXT || {}).currency) || 'USD';
    } catch (error) {}
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(amount); }
    catch (error) { return '$' + amount.toFixed(2); }
  }
  function queryFilterTags() {
    var query = params();
    var raw = query.get('integy_filter') || query.get('integy_filters') || query.get('integy_tag_filter') || '';
    return text(raw).replace(/\s+/g, '+').split('+').map(function (tag) { return tag.trim(); }).filter(Boolean);
  }
  function sourceBase() {
    var info = pathInfo();
    var base = String(location.pathname || '/collections/' + info.handle).replace(/\/$/, '');
    if (!info.tags) {
      var tags = queryFilterTags();
      if (tags.length) {
        base += '/' + tags.map(function (tag) {
          return encodeURIComponent(tag).replace(/%2B/gi, '+');
        }).join('+');
      }
    }
    return base;
  }
  function sortValue() { var s=params().get('sort_by') || ''; return document.documentElement.hasAttribute('data-integy-b2b') && (s==='price-ascending'||s==='price-descending') ? 'title-ascending' : s; }
  function cacheKey() {
    var query = params();
    var filterBits = [];
    query.forEach(function (value, key) {
      if ((/^filter\./.test(key) && key !== 'filter.v.availability') || /^integy_(?:filter|filters|tag_filter)$/.test(key)) {
        filterBits.push(key + '=' + value);
      }
    });
    filterBits.sort();
    return 'integy:v771:stock:' + (document.documentElement.hasAttribute('data-integy-b2b') ? 'business' : 'retail') + ':' + stockMode() + ':' + sourceBase() + ':sort=' + sortValue() + ':' + filterBits.join('&');
  }
  function storageRead(storage) {
    if (!storage) return null;
    try {
      var raw = storage.getItem(cacheKey());
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !Array.isArray(obj.items) || !obj.time) return null;
      var age = Date.now() - Number(obj.time || 0);
      if (age < 0 || age > FRESH_CACHE_TTL) return null;
      obj.age = age;
      obj.scannedPages = Math.max(0, Number(obj.scannedPages || 0));
      obj.sourcePages = Math.max(obj.scannedPages, Number(obj.sourcePages || 0));
      obj.sourceItemsChecked = Math.max(0, Number(obj.sourceItemsChecked || 0));
      obj.complete = obj.complete === true || (obj.sourcePages > 0 && obj.scannedPages >= obj.sourcePages);
      return obj;
    } catch (error) { return null; }
  }
  // Safari/private-mode storage can be disabled. Retain same-page progressive
  // discovery even when sessionStorage is unavailable or its quota is exhausted.
  var memoryPayload = null;
  var memoryKey = '';
  function cachedPayload() {
    var business = document.documentElement.hasAttribute('data-integy-b2b');
    var session = null;
    if(!business) { try { session = storageRead(window.sessionStorage); } catch (error) {} }
    if (session) return { payload: session, fresh: true, source: 'session' };
    if (memoryPayload && memoryKey === cacheKey() && Date.now() - memoryPayload.time < FRESH_CACHE_TTL) {
      return { payload: memoryPayload, fresh: true, source: 'memory' };
    }
    return null;
  }
  function writeCache(payload) {
    try {
      var record = JSON.stringify({
        time: Date.now(),
        sourceTotal: Number(payload.sourceTotal || 0),
        sourcePages: Number(payload.sourcePages || 0),
        scannedPages: Number(payload.scannedPages || 0),
        sourceItemsChecked: Number(payload.sourceItemsChecked || 0),
        complete: payload.complete === true,
        items: payload.items || []
      });
      // Keep a small page-level memory fallback even when session storage is blocked.
      memoryPayload = JSON.parse(record);
      memoryKey = cacheKey();
      // Cross-navigation reuse is session-only. Never let a prior theme interpret
      // this partial list as a complete V651/V663 inventory scan.
      if (!document.documentElement.hasAttribute('data-integy-b2b') && record.length < 2600000) sessionStorage.setItem(cacheKey(), record);
    } catch (error) {
      // JSON/session quota failures should not stop visible result rendering.
    }
  }
  function sourceUrl(page, requestNonce) {
    var url = new URL(sourceBase(), location.origin);
    url.searchParams.set('view', 'integy-stock-100');
    url.searchParams.set('page', String(page));
    var sort = sortValue();
    if (sort) url.searchParams.set('sort_by', sort);
    // V696: /collections/all deliberately uses the unfiltered 100-row Shopify
    // source and trusts each row's live `available` boolean. Alternate-view
    // availability filtering has proven unreliable on this 25k-product collection
    // and can return mixed stock. Scanning the unfiltered source remains bounded
    // (2 source pages for in-stock page 1, up to 10 for sold-out page 1) and lets
    // appendMatches() dedupe exact SKUs before the 72-card visible slice is built.
    if (!v691AllCollection()) {
      if (stockMode() === 'in') url.searchParams.set('filter.v.availability', '1');
      else if (stockMode() === 'out') url.searchParams.set('filter.v.availability', '0');
    }
    params().forEach(function (value, key) {
      if (/^filter\./.test(key) && key !== 'filter.v.availability') url.searchParams.append(key, value);
    });
    // A retry must be a genuinely fresh request, not another hit on the same failed edge/cache entry.
    if (requestNonce) url.searchParams.set('_integy_retry', String(requestNonce));
    return url.pathname + '?' + url.searchParams.toString();
  }
  function fetchWithTimeout(url, forceFresh) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = window.setTimeout(function () {
      if (controller) controller.abort();
    }, REQUEST_TIMEOUT);
    return fetch(url, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      cache: forceFresh ? 'no-store' : 'no-cache',
      signal: controller ? controller.signal : undefined
    }).then(function (response) {
      if (!response.ok) {
        var error = new Error('HTTP ' + response.status);
        error.status = response.status;
        throw error;
      }
      return response.json();
    }).finally(function () {
      window.clearTimeout(timer);
    });
  }
  function fetchPage(page, attempt, requestNonce) {
    attempt = Number(attempt || 0);
    var autoNonce = requestNonce || (attempt > 0 ? ('auto-' + Date.now().toString(36) + '-' + attempt) : '');
    return fetchWithTimeout(sourceUrl(page, autoNonce), !!autoNonce).then(function (data) {
      if (!data || !Array.isArray(data.items)) throw new Error('Invalid stock view on page ' + page);
      return data;
    }).catch(function (error) {
      if (attempt + 1 >= MAX_ATTEMPTS) throw error;
      var delay = error && error.status === 429 ? 1400 : (500 + attempt * 350);
      return wait(delay).then(function () { return fetchPage(page, attempt + 1, requestNonce); });
    });
  }

  var lastPartialPaint = 0;
  function loadingNode() {
    return document.querySelector('[data-integy-v651-large-loading],.integy-v651-large-stock-loading-message');
  }
  function setLoadingText(message, completed, total, state) {
    var node = loadingNode();
    if (!node) return;
    node.setAttribute('data-state', state || 'loading');
    var label = node.querySelector('[data-integy-v651-large-loading-text]') || node;
    if (label) label.textContent = message;
    var progress = node.querySelector('[data-integy-v651-large-progress]');
    if (progress) {
      var pct = total > 0 ? Math.round(Math.max(0, Math.min(total, completed)) * 100 / total) : 0;
      progress.max = 100;
      progress.value = pct;
      progress.setAttribute('aria-valuetext', pct + '%');
    }
  }
  function progress(completed, total) {
    var pct = total > 0 ? Math.round(completed * 100 / total) : 0;
    setLoadingText('Loading products… ' + pct + '%', completed, total, 'loading');
  }

  function appendMatches(target, data) {
    var seen = Object.create(null);
    target.forEach(function (item) {
      var key = text(item && (item.sku || item.url)).toUpperCase();
      if (key) seen[key] = true;
    });
    var list = (data && data.items) || [];
    for (var itemIndex = 0; itemIndex < list.length; itemIndex += 1) {
      var item = list[itemIndex];
      if (!item || (stockMode() === 'in' ? item.available !== true : item.available !== false)) continue;
      var key = text(item.sku || item.url).toUpperCase();
      if (!key || seen[key]) continue;
      seen[key] = true;
      target.push(item);
    }
    return target;
  }
  function compactViewport() {
    try { return !!(window.matchMedia && window.matchMedia('(max-width: 739px)').matches); }
    catch (error) { return (window.innerWidth || 1024) <= 739; }
  }
  function requestedPageNumber() {
    return Math.max(1, parseInt(params().get('page') || '1', 10) || 1);
  }
  function v691AllCollection() { return pathInfo().handle === 'all'; }
  function v691AllScanCap(requestedPage) {
    // V696: /collections/all uses live Shopify rows with row-level availability. In-stock density is high;
    // sold-out density is lower, so scan a bounded number of 100-row source pages
    // only until the requested 72-card page is full. Never crawl the whole catalog.
    if (!v691AllCollection()) return MAX_FRESH_DEEP_SOURCE_PAGES;
    var perPageBudget = stockMode() === 'out' ? 10 : 2;
    return Math.min(32, Math.max(2, requestedPage * perPageBudget));
  }
  function targetMatchCount(requestedPage) {
    return Math.max(PAGE_SIZE, requestedPage * PAGE_SIZE);
  }
  function freshDeepLinkBudget(requestedPage) {
    var minimumSourcePages = Math.ceil(targetMatchCount(requestedPage) / SOURCE_PAGE_SIZE);
    if (v691AllCollection()) return Math.max(1, v691AllScanCap(requestedPage));
    return Math.max(1, Math.min(MAX_FRESH_DEEP_SOURCE_PAGES, minimumSourcePages));
  }
  function shouldFetchMore(state, requestedPage, extraSourcePages) {
    if (!state || state.complete) return false;
    // A fresh deep link has no known sourcePages yet; always fetch page 1 first.
    if (!state.sourcePages && !state.scannedPages) return true;
    if (extraSourcePages > 0) {
      // Explicit button: only one 100-product source page per click, never the full remaining catalog.
      return state.scannedPages < Math.min(state.sourcePages || (state.scannedPages + 1), extraSourcePages);
    }
    if (requestedPage <= 1) {
      if (v691AllCollection()) {
        var allCap = Math.min(v691AllScanCap(requestedPage), state.sourcePages || v691AllScanCap(requestedPage));
        return state.items.length < PAGE_SIZE && state.scannedPages < allCap;
      }
      // Other large collections retain V681's strict first-page request budget.
      return state.scannedPages < Math.min(INITIAL_SOURCE_PAGES, state.sourcePages || INITIAL_SOURCE_PAGES);
    }
    return state.items.length < targetMatchCount(requestedPage) && state.scannedPages < state.sourcePages;
  }
  var inFlight = false;
  function partialPaint(state, requestedPage) {
    // Do not silently substitute the last known page while loading a deep link.
    // Rendering page N requires at least its first match, unless the scan is complete.
    var enoughForRequestedPage = state.complete || state.items.length > (requestedPage - 1) * PAGE_SIZE;
    if (!enoughForRequestedPage) return;
    var now = Date.now();
    if (now - lastPartialPaint < 300) return;
    lastPartialPaint = now;
    render(state, { partial: !state.complete, complete: !!state.complete, demand: true });
  }
  function scanDemand(cachePayload, extraSourcePages, requestNonce) {
    var requestedPage = requestedPageNumber();
    extraSourcePages = Math.max(0, Number(extraSourcePages || 0));
    var state = cachePayload ? {
      sourceTotal: Number(cachePayload.sourceTotal || 0),
      sourcePages: Number(cachePayload.sourcePages || 0),
      scannedPages: Number(cachePayload.scannedPages || 0),
      sourceItemsChecked: Number(cachePayload.sourceItemsChecked || 0),
      complete: cachePayload.complete === true,
      items: (cachePayload.items || []).slice()
    } : {
      sourceTotal: 0, sourcePages: 0, scannedPages: 0,
      sourceItemsChecked: 0, complete: false, items: []
    };
    // Page 1 is always one 100-product source request. Sequential navigation adds
    // at most one source page at a time. A fresh deep link receives only the minimum
    // 100-product pages needed to make its 72-card page possible, capped at four.
    var budget = extraSourcePages > 0 ? extraSourcePages :
      (v691AllCollection() ? v691AllScanCap(requestedPage) :
        (requestedPage <= 1 ? INITIAL_SOURCE_PAGES :
          (state.scannedPages > 0 ? state.scannedPages + 1 : freshDeepLinkBudget(requestedPage))));
    function finish() {
      state.complete = state.sourcePages > 0 && state.scannedPages >= state.sourcePages;
      writeCache(state);
      return state;
    }
    function fetchNextPage() {
      if (state.complete || state.scannedPages >= budget ||
          !shouldFetchMore(state, requestedPage, extraSourcePages ? budget : 0)) return Promise.resolve(finish());
      var nextPage = state.scannedPages + 1;
      setLoadingText('Loading products…', state.scannedPages, state.sourcePages || Math.max(nextPage, INITIAL_SOURCE_PAGES), 'loading');
      return fetchPage(nextPage, 0, requestNonce).then(function (data) {
        if (!state.sourcePages) state.sourcePages = Math.max(1, Number(data.pages) || 1);
        state.sourceTotal = Number(data.total || state.sourceTotal || 0);
        state.scannedPages = nextPage;
        state.sourceItemsChecked += Array.isArray(data.items) ? data.items.length : 0;
        appendMatches(state.items, data);
        state.complete = state.scannedPages >= state.sourcePages;
        writeCache(state);
        if (state.items.length) partialPaint(state, requestedPage);
        return fetchNextPage();
      });
    }
    // Cache-only page visits produce zero network traffic.
    if (state.sourcePages && !extraSourcePages && !shouldFetchMore(state, requestedPage, 0))
      return Promise.resolve(finish());
    return fetchNextPage();
  }
  function normalizedIndexTerms() {
    var info = pathInfo();
    var terms = [];
    if (info.tags) {
      String(info.tags).split(/[+/]/).forEach(function (part) {
        part = decodeURIComponent(String(part || '')).trim().toLowerCase();
        if (part) terms.push(part.replace(/-/g, ' '));
      });
    }
    queryFilterTags().forEach(function (part) {
      part = decodeURIComponent(String(part || '')).trim().toLowerCase();
      if (part) terms.push(part.replace(/-/g, ' '));
    });
    return terms;
  }
  function sortIndexedItems(items) {
    var sort = sortValue();
    var copy = items.slice();
    if (sort === 'price-ascending') copy.sort(function (a,b) { return Number(a.price || 0) - Number(b.price || 0) || text(a.title).localeCompare(text(b.title)); });
    else if (sort === 'price-descending') copy.sort(function (a,b) { return Number(b.price || 0) - Number(a.price || 0) || text(a.title).localeCompare(text(b.title)); });
    else if (sort === 'title-ascending') copy.sort(function (a,b) { return text(a.title).localeCompare(text(b.title)); });
    else if (sort === 'title-descending') copy.sort(function (a,b) { return text(b.title).localeCompare(text(a.title)); });
    return copy;
  }
  function clearanceIndexedOutPayload() {
    var url = window.INTEGY_V676_CLEARANCE_SOLDOUT_INDEX_URL || '';
    if (!url) return Promise.reject(new Error('V676 Clearance sold-out index URL unavailable'));
    return fetchWithTimeout(url, false).then(function (data) {
      if (!data || !Array.isArray(data.items)) throw new Error('Invalid V676 Clearance sold-out index');
      var terms = normalizedIndexTerms();
      var items = data.items.filter(function (item) {
        if (!item || item.available === true) return false;
        if (!terms.length) return true;
        var hay = text(item.search || (text(item.sku) + ' ' + text(item.title) + ' ' + text(item.url))).toLowerCase();
        return terms.every(function (term) { return hay.indexOf(term) >= 0; });
      }).map(function (item) {
        return {
          sku: item.sku, title: item.title, url: item.url, image: item.image,
          price: Number(item.price || 0), compare: Number(item.compare || 0),
          available: false
        };
      });
      items = sortIndexedItems(items);
      var payload = {
        sourceTotal: items.length,
        sourcePages: 1,
        scannedPages: 1,
        sourceItemsChecked: items.length,
        complete: true,
        items: items
      };
      writeCache(payload);
      return payload;
    });
  }

  function scanCompleteOutOfStock(cachePayload) {
    // A complete cache makes Page 2/3/etc. zero-network and exact.
    if (cachePayload && cachePayload.complete === true && Array.isArray(cachePayload.items)) {
      return Promise.resolve(cachePayload);
    }

    var requestedPage = requestedPageNumber();
    var state = {
      sourceTotal: 0, sourcePages: 0, scannedPages: 0,
      sourceItemsChecked: 0, complete: false, items: []
    };

    setLoadingText('Loading sold-out products…', 0, 1, 'loading');
    return fetchPage(1, 0).then(function (first) {
      state.sourcePages = Math.max(1, Number(first.pages) || 1);
      state.sourceTotal = Number(first.total || 0);

      // If a future large collection has an unusually huge sold-out universe, do not
      // replace one performance problem with another. Fall back to the existing
      // demand model after the first filtered source page.
      if (state.sourcePages > FULL_OUT_SOURCE_PAGE_CAP) {
        state.scannedPages = 1;
        state.sourceItemsChecked = Array.isArray(first.items) ? first.items.length : 0;
        appendMatches(state.items, first);
        state.complete = state.scannedPages >= state.sourcePages;
        writeCache(state);
        return scanDemand(state, 0);
      }

      var pages = new Array(state.sourcePages + 1);
      pages[1] = first;
      var completed = 1;
      var nextPage = 2;
      setLoadingText('Loading sold-out products… ' + completed + '/' + state.sourcePages, completed, state.sourcePages, 'loading');

      function worker() {
        var page = nextPage++;
        if (page > state.sourcePages) return Promise.resolve();
        return fetchPage(page, 0).then(function (data) {
          pages[page] = data;
          completed += 1;
          setLoadingText('Loading sold-out products… ' + completed + '/' + state.sourcePages, completed, state.sourcePages, 'loading');
          return worker();
        });
      }

      var workerCount = Math.max(1, Math.min(FULL_OUT_WORKERS, state.sourcePages - 1));
      var jobs = [];
      for (var workerIndex = 0; workerIndex < workerCount; workerIndex += 1) jobs.push(worker());
      return Promise.all(jobs).then(function () {
        state.items = [];
        state.sourceItemsChecked = 0;
        for (var pageIndex = 1; pageIndex <= state.sourcePages; pageIndex += 1) {
          var data = pages[pageIndex];
          if (!data || !Array.isArray(data.items)) throw new Error('Sold-out source page ' + pageIndex + ' missing');
          state.sourceItemsChecked += data.items.length;
          appendMatches(state.items, data);
        }
        state.scannedPages = state.sourcePages;
        state.complete = true;
        writeCache(state);
        return state;
      });
    });
  }

  function grid() { return document.querySelector('[data-productgrid-items],.productgrid--items'); }
  function card(item, index) {
    var b2b = document.documentElement.hasAttribute('data-integy-b2b');
    var title = esc(item.title);
    var sku = esc(item.sku);
    var url = esc(item.url);
    var image = esc(item.image);
    var current = Number(item.price) || 0;
    var compare = b2b ? 0 : Number(item.compare) || 0;
    var price = b2b ? 'See company price on product page' : esc(money(current));
    var saving = compare > current && compare > 0 ? Math.max(1, Math.round((compare - current) * 100 / compare)) : 0;
    var available = item.available === true;
    var variantId = Number(item.variant_id || 0);
    var action = available && variantId
      ? '<button class="productitem--action-trigger button-primary integy-v547-direct-atc" type="button" data-integy-v547-atc data-variant-id="' + variantId + '" data-product-url="' + url + '">Add to Cart</button>'
      : '<a class="productitem--action-trigger button-primary integy-v547-direct-atc" href="' + url + '">View product</a>';
    if (b2b) action = '<a class="productitem--action-trigger button-primary integy-v547-choose-options" href="' + url + '">View company price</a>';
    return '<div class="productgrid--item integy-v104-collection-card-lite integy-v115-collection-card-lite integy-v307-canonical-card imagestyle--natural" data-product-item data-sku="' + sku + '" data-product-available="' + (available ? 'true' : 'false') + '" data-integy-v548-stock-verified="true" data-integy-v700-live-row-verified="true" data-integy-v651-large-card="true">' +
      '<div class="productitem" data-product-item-content><div class="productitem__container">' +
      '<div class="productitem__image-container"><a class="productitem--image-link" href="' + url + '" tabindex="-1" aria-label="' + title + '"><figure class="productitem--image" data-product-item-image>' +
      (image ? '<img class="productitem--image-primary integy-v104-collection-image" src="' + image + '" alt="' + title + '" loading="' + (index < (compactViewport() ? 4 : 8) ? 'eager' : 'lazy') + '" decoding="async" width="480" height="480">' : '<span class="placeholder--image" aria-hidden="true"></span>') +
      '<span class="visually-hidden">' + title + '</span></figure></a></div>' +
      '<div class="productitem--info"><h2 class="productitem--title"><a href="' + url + '">' + title + '</a></h2>' +
      '<div class="integy-v557-card-statusline integy-v559-card-statusline"><div class="integy-v426-card-stock integy-v549-card-stock ' + (available ? 'is-in-stock' : 'is-sold-out') + '">' + (available ? 'In stock' : 'Sold out') + '</div>' +
      (sku ? '<div class="integy-product-card-sku" title="' + sku + '">' + sku + '</div>' : '') + '</div>' +
      '<div class="price productitem__price integy-v410-card-price"><div class="integy-v410-card-price__main"><span class="money integy-v410-card-price__current">' + price + '</span>' +
      (compare > current ? '<s class="money integy-v410-card-price__compare">' + esc(money(compare)) + '</s>' : '') + '</div>' +
      (saving ? '<span class="integy-v410-card-price__saving">Save ' + saving + '%</span>' : '') + '</div>' +
      '<div class="productitem--actions integy-v547-direct-actions">' + action + '</div>' +
      '</div></div></div></div>';
  }
  function pageHref(page) {
    var url = new URL(location.href);
    if (page <= 1) url.searchParams.delete('page');
    else url.searchParams.set('page', String(page));
    return url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash;
  }
  function paginationHtml(current, knownPages, hasMoreSource, complete, totalMatches) {
    if (knownPages <= 1 && !hasMoreSource) return '';
    if (!complete && current > knownPages) {
      return '<nav class="pagination--container integy-v665-demand-pending" aria-label="Collection pages"><a href="' + esc(pageHref(Math.max(1, knownPages))) + '">Back to loaded results</a><span role="status"> More products are available for this page.</span></nav>';
    }
    var html = '<div class="pagination--container integy-v651-large-pagination integy-v664-demand-pagination" data-integy-v651-large-pagination data-integy-v664-demand-pagination><ul class="pagination">';
    if (current > 1) html += '<li><a href="' + esc(pageHref(current - 1)) + '" aria-label="Previous page">‹ Previous</a></li>';
    var start = Math.max(1, current - 2);
    var end = Math.max(current, Math.min(knownPages, current + 2));
    if (start > 1) {
      html += '<li><a href="' + esc(pageHref(1)) + '">1</a></li>';
      if (start > 2) html += '<li class="pagination--ellipsis" aria-hidden="true">…</li>';
    }
    for (var number = start; number <= end; number += 1) {
      html += number === current
        ? '<li class="pagination--active"><span aria-current="page">' + number + '</span></li>'
        : '<li><a href="' + esc(pageHref(number)) + '">' + number + '</a></li>';
    }
    if (complete && end < knownPages) {
      if (end < knownPages - 1) html += '<li class="pagination--ellipsis" aria-hidden="true">…</li>';
      html += '<li><a href="' + esc(pageHref(knownPages)) + '">' + knownPages + '</a></li>';
    }
    if (current < knownPages) html += '<li><a href="' + esc(pageHref(current + 1)) + '" aria-label="Next page">Next ›</a></li>';
    return html + '</ul></div>';
  }
  function updateCount(total, partial, visibleOnPage, currentPage, pageCount, complete) {
    var mode = stockMode();
    var clearanceExactOut = complete && mode === 'out' && pathInfo().handle === 'on-sale-clearance-up-to-80';
    var label = clearanceExactOut
      ? (total + ' sold-out ' + (total === 1 ? 'product' : 'products'))
      : (partial ? (total + '+ products found so far') : (total + ' ' + (total === 1 ? 'product' : 'products')));
    var candidates = document.querySelectorAll('.collection--product-count,.productgrid--count,.integy-collection-meta .integy-chip,[data-integy-collection-product-count]');
    Array.prototype.forEach.call(candidates, function (element) {
      if (!element || (!/products?|checking|refreshing|found/i.test(element.textContent || '') && !element.hasAttribute('data-integy-collection-product-count'))) return;
      element.textContent = label;
      element.setAttribute('data-integy-v651-count', String(total));
      element.setAttribute('data-integy-v681-authoritative-count', 'true');
      element.toggleAttribute('data-integy-v664-partial-count', !!partial);
      element.removeAttribute('data-integy-collection-count-loading');
    });
    var statuses = document.querySelectorAll('[data-integy-v449-stock-status],[data-integy-v548-stock-status]');
    Array.prototype.forEach.call(statuses, function (status) {
      if (clearanceExactOut) {
        status.textContent = 'Showing ' + visibleOnPage + ' of ' + total + ' sold-out ' + (total === 1 ? 'product' : 'products') + (pageCount > 1 ? ' — page ' + currentPage + ' of ' + pageCount : '');
      } else {
        status.textContent = total + (partial ? '+ ' : ' ') + 'live ' + (mode === 'in' ? 'in-stock' : 'out-of-stock') + ' match' + (total === 1 ? '' : 'es') + (partial ? ' loaded' : '');
      }
      status.setAttribute('data-integy-v681-authoritative-status', 'true');
    });
  }
  function clearForeignEmptyStates() {
    Array.prototype.forEach.call(document.querySelectorAll('.integy-v426-empty-state,.integy-v643-sale-empty-state'), function (node) { node.remove(); });
  }
  function emptyState(currentGrid, total) {
    var existing = document.querySelector('.integy-v651-large-empty-state');
    if (total > 0) {
      if (existing) existing.remove();
      return;
    }
    if (!existing) {
      existing = document.createElement('section');
      existing.className = 'productgrid--no-results integy-v651-large-empty-state';
      existing.setAttribute('role', 'status');
      if (currentGrid && currentGrid.parentNode) currentGrid.parentNode.insertBefore(existing, currentGrid.nextSibling);
    }
    existing.innerHTML = stockMode() === 'in' ? '<h2>No in-stock products match this filter combination</h2><p>Try another filter, choose All items, or return to Out of stock.</p>' : '<h2>No sold-out products match this filter combination</h2><p>Try another filter, choose All items, or return to In stock.</p>';
  }
  function removeLegacyPagination() {
    Array.prototype.forEach.call(document.querySelectorAll('.pagination--container,.productgrid--pagination,.pagination-wrapper'), function (node) {
      if (!node.matches('[data-integy-v651-large-pagination]')) node.remove();
    });
  }
  function removeLoadingMessage() {
    var message = loadingNode();
    if (message) message.remove();
  }
  function ensureLoadingMessage() {
    var node = loadingNode();
    if (node) return node;
    var currentGrid = grid();
    if (!currentGrid || !currentGrid.parentNode) return null;
    var div = document.createElement('div');
    div.className = 'integy-v651-large-stock-loading-message';
    div.setAttribute('data-integy-v651-large-loading', '');
    div.setAttribute('role', 'status');
    div.setAttribute('aria-live', 'polite');
    div.innerHTML = '<span data-integy-v651-large-loading-text>Checking current ' + (stockMode() === 'in' ? 'in-stock' : 'sold-out') + ' items…</span><progress data-integy-v651-large-progress max="100" value="0" aria-label="Inventory scan progress"></progress>';
    currentGrid.parentNode.insertBefore(div, currentGrid);
    return div;
  }
  function render(payload, options) {
    options = options || {};
    var currentGrid = grid();
    if (!currentGrid) throw new Error('Product grid missing');
    var items = payload.items || [];
    var total = items.length;
    var complete = options.complete === true || payload.complete === true;
    var hasMoreSource = !complete && Number(payload.scannedPages || 0) < Number(payload.sourcePages || 0);
    var knownPages = Math.max(1, Math.ceil(total / PAGE_SIZE));
    var requested = Math.max(1, parseInt(params().get('page') || '1', 10) || 1);
    var current = complete ? Math.min(requested, knownPages) : requested;
    // Keep requested page identity while source records for it are still missing.
    // Do not display page-one/page-two items as a substitute for page N.
    if (complete && requested !== current) {
      try { history.replaceState(history.state, '', pageHref(current)); } catch (error) {}
    }
    var subset = items.slice((current - 1) * PAGE_SIZE, current * PAGE_SIZE);
    // The checked prefix is immutable during a one-page demand fetch. Preserve
    // already painted card DOM/images and shopper scroll position if unchanged.
    var visibleKey = JSON.stringify(subset.map(function (item) {
      return [item.sku || item.url, item.available === true, item.price, item.compare, item.image];
    }));
    var canKeepVisibleCards = currentGrid.getAttribute('data-integy-v651-large-owner') === 'true' &&
      currentGrid.getAttribute('data-integy-v668-visible-key') === visibleKey &&
      currentGrid.getAttribute('data-integy-v668-visible-page') === String(current);
    if (!canKeepVisibleCards) currentGrid.innerHTML = subset.map(card).join('');
    currentGrid.setAttribute('data-integy-v668-visible-key', visibleKey);
    currentGrid.setAttribute('data-integy-v668-visible-page', String(current));
    var pendingDeepPage = !complete && current > knownPages;
    currentGrid.setAttribute('data-integy-v651-large-total', String(total));
    currentGrid.setAttribute('data-integy-v651-large-source-total', String(Number(payload.sourceTotal || 0)));
    currentGrid.setAttribute('data-integy-v651-large-owner', 'true');
    currentGrid.setAttribute('data-integy-v691-authoritative-owner', 'true');
    currentGrid.setAttribute('data-integy-v681-visible-on-page', String(subset.length));
    currentGrid.setAttribute('data-integy-v664-source-pages-scanned', String(Number(payload.scannedPages || 0)));
    currentGrid.setAttribute('data-integy-v664-source-pages-total', String(Number(payload.sourcePages || 0)));
    currentGrid.setAttribute('aria-busy', 'false');
    clearForeignEmptyStates();
    // Never claim a zero-result state while unscanned source pages still exist.
    emptyState(currentGrid, complete ? total : (total || 1));
    updateCount(total, hasMoreSource, subset.length, current, knownPages, complete);
    removeLegacyPagination();
    var old = document.querySelector('[data-integy-v651-large-pagination]');
    if (old) old.remove();
    var pagination = paginationHtml(current, knownPages, hasMoreSource, complete, total);
    if (pagination && (total > 0 || hasMoreSource)) currentGrid.insertAdjacentHTML('afterend', pagination);

    ROOT.classList.remove('integy-v651-large-stock-loading', 'integy-v651-large-stock-failed', 'integy-v651-large-stock-refreshing', 'integy-v594-stock-paint-guard');
    ROOT.classList.add('integy-v651-large-stock-ready', 'integy-v664-demand-ready', 'integy-v696-large-stock-ready');
    var staleError = document.querySelector('.integy-v651-large-error');
    if (staleError) {
      if (staleError === loadingNode()) staleError.classList.remove('integy-v651-large-error');
      else staleError.remove();
    }

    // Rebuild only V671's bottom continuation UI; do not alter native toolbar
    // or content layout outside this non-indexed oversized collection owner.
    var priorBottom = document.querySelector('[data-integy-v668-bottom-controls]');
    if (priorBottom) priorBottom.remove();
    if (hasMoreSource) {
      var bottom = document.createElement('div');
      bottom.className = 'integy-v668-bottom-controls';
      bottom.setAttribute('data-integy-v668-bottom-controls', '');
      bottom.setAttribute('role', 'region');
      bottom.setAttribute('aria-label', 'Find more products');
      bottom.innerHTML = '<span class="integy-v668-bottom-summary">' +
        (pendingDeepPage ? 'More products are available.' : 'More products are available.') +
        '</span><button type="button" class="button-secondary integy-v665-load-more integy-v668-bottom-button" data-integy-v665-scan-next>Show more products</button>';
      var ownedPager = document.querySelector('[data-integy-v651-large-pagination],.integy-v665-demand-pending');
      var anchor = ownedPager || currentGrid;
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(bottom, anchor.nextSibling);
    }
    // V672: normal partial browsing stays visually quiet above the grid. The single
    // continuation control lives below the results where shoppers naturally reach it.
    removeLoadingMessage();

    try {
      document.dispatchEvent(new CustomEvent('integy:v696:large-stock-ready', {
        detail: { count: total, page: current, pagesKnown: knownPages, sourceTotal: Number(payload.sourceTotal || 0), scannedPages: Number(payload.scannedPages || 0), complete: complete }
      }));
    } catch (error) {}
  }
  function recoveryBackPage() {
    var cached = cachedPayload();
    var count = cached && cached.payload && Array.isArray(cached.payload.items) ? cached.payload.items.length : 0;
    var loadedPages = Math.max(1, Math.ceil(count / PAGE_SIZE));
    return Math.max(1, Math.min(Math.max(1, requestedPageNumber() - 1), loadedPages));
  }
  function persistentFailure(error, staleWasRendered) {
    ROOT.classList.remove('integy-v651-large-stock-loading', 'integy-v651-large-stock-refreshing');
    var currentGrid = grid();
    if (currentGrid) currentGrid.setAttribute('aria-busy', 'false');

    if (staleWasRendered) {
      // Existing products remain usable. Do not interrupt normal browsing with an error
      // banner or Retry button; simply restore the continuation control for a later try.
      ROOT.classList.add('integy-v651-large-stock-ready');
      removeLoadingMessage();
      Array.prototype.forEach.call(document.querySelectorAll('[data-integy-v665-scan-next]'), function (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = 'Show more products';
      });
    } else {
      // V675: a dead-end error message does not help a shopper. If all quiet demand
      // attempts fail before we paint owned results, release the early loading guard
      // and fall back to Shopify's server-rendered collection grid/pagination that is
      // already underneath this owner. No banner, Retry button, or forced navigation.
      ROOT.classList.remove('integy-v651-large-stock-failed', 'integy-v664-demand-ready');
      ROOT.classList.add('integy-v675-native-fallback');
      removeLoadingMessage();
      if (currentGrid) {
        currentGrid.removeAttribute('aria-busy');
        currentGrid.removeAttribute('data-integy-v651-large-owner');
        currentGrid.removeAttribute('data-integy-v668-visible-key');
        currentGrid.removeAttribute('data-integy-v668-visible-page');
      }
    }
    try { console.warn('[Integy V681] Large collection stock request failed after quiet retries; native Shopify results remain visible', error); } catch (ignore) {}
  }
  function scanOneMore() {
    if (inFlight) return;
    var cache = cachedPayload();
    if (!cache || !cache.payload || cache.payload.complete) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-integy-v665-scan-next]'), function (button) {
      button.disabled = true; button.setAttribute('aria-busy', 'true');
      button.textContent = 'Loading more…';
    });
    inFlight = true;
    scanDemand(cache.payload, cache.payload.scannedPages + 1).then(function (payload) {
      render(payload, { partial: !payload.complete, complete: !!payload.complete, demand: true });
    }).catch(function (error) {
      // Previously displayed matches remain visible if this one-page request fails.
      persistentFailure(error, true);
    }).finally(function () { inFlight = false; });
  }
  function boot() {
    document.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest('[data-integy-v665-scan-next]')) {
        event.preventDefault();
        scanOneMore();
      }
    });
    var currentGrid = grid();
    if (currentGrid) currentGrid.setAttribute('aria-busy', 'true');
    ensureLoadingMessage();

    var cache = cachedPayload();

    // V676: Clearance sold-out mode is served from the compact 115-item indexed set.
    // Do not rely on Shopify availability filtering inside an alternate collection view:
    // that view can still return mixed stock candidates on >5,000-product collections.
    if (stockMode() === 'out' && pathInfo().handle === 'on-sale-clearance-up-to-80') {
      if (cache && cache.fresh && cache.payload && cache.payload.complete === true) {
        render(cache.payload, { partial: false, complete: true, cached: true, indexedOut: true });
        return;
      }
      setLoadingText('Loading sold-out products…', 0, 1, 'loading');
      inFlight = true;
      clearanceIndexedOutPayload().then(function (payload) {
        render(payload, { partial: false, complete: true, indexedOut: true });
      }).catch(function (error) { persistentFailure(error, false); })
        .finally(function () { inFlight = false; });
      return;
    }

    setLoadingText('Checking the first 100 products…', 0, INITIAL_SOURCE_PAGES, 'loading');
    if (cache && cache.fresh && cache.payload) {
      var requested = requestedPageNumber();
      var cached = cache.payload;
      if (!shouldFetchMore(cached, requested, 0)) {
        render(cached, { partial: !cached.complete, complete: !!cached.complete, cached: true, demand: true });
        return;
      }
    }
    inFlight = true;
    scanDemand(cache && cache.fresh ? cache.payload : null, 0).then(function (payload) {
      render(payload, { partial: !payload.complete, complete: !!payload.complete, demand: true });
    }).catch(function (error) { persistentFailure(error, false); })
      .finally(function () { inFlight = false; });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
